import { render, staticRenderFns } from "./AmlaExtract.vue?vue&type=template&id=9c8857ce&scoped=true&"
import script from "./AmlaExtract.vue?vue&type=script&lang=js&"
export * from "./AmlaExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8857ce",
  null
  
)

export default component.exports